import React from 'react';
import { Helmet } from 'react-helmet';
import TournamentList from 'containers/TournamentList';
import PageTitleBar from 'components/PageTitleBar';
import TournamentIcon from 'resources/FeatureIcons/Button-Tournaments.svg';
import './TournamentListPage.css';

function TournamentListPage({ location }) {
  return (
    <div className="tournament-list-page">
      <Helmet>
        <title>Tournaments</title>
      </Helmet>
      <PageTitleBar title="Tournaments" icon={TournamentIcon} />
      <TournamentList location={location} />
    </div>
  );
}

export default TournamentListPage;
